import { PromoStore } from '../store/promo-store';
export class PromoService {
    constructor() {
        this.listeners = [];
        this.onStateChanged = (state) => {
            var _a, _b;
            this.updateBadgeModal(state);
            if (state.hasSubmittedPromo) {
                (_a = this.modalPromo) === null || _a === void 0 ? void 0 : _a.classList.remove('active');
                (_b = this.modalSuccess) === null || _b === void 0 ? void 0 : _b.classList.add('active');
            }
        };
        this.onBadgeClick = () => {
            var _a, _b;
            const { hasSubmittedPromo } = PromoStore.getState();
            if (hasSubmittedPromo) {
                (_a = this.modalSuccess) === null || _a === void 0 ? void 0 : _a.classList.add('active');
            }
            else {
                (_b = this.modalPromo) === null || _b === void 0 ? void 0 : _b.classList.add('active');
            }
        };
        this.onPromoSubmit = (e) => {
            e.preventDefault();
            PromoStore.getState().submitPromo();
        };
        this.badge = document.getElementById('first-order-promo-badge');
        this.modalPromo = document.getElementById('modal_first_order');
        this.modalSuccess = document.getElementById('modal_first_order_success');
    }
    init() {
        var _a, _b;
        const currentState = PromoStore.getState();
        this.updateBadgeModal(currentState);
        this.onStateChanged(currentState);
        this.listeners.push(PromoStore.subscribe(this.onStateChanged));
        (_a = this.badge) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.onBadgeClick);
        (_b = this.modalPromo) === null || _b === void 0 ? void 0 : _b.addEventListener('submit', this.onPromoSubmit);
    }
    updateBadgeModal(state) {
        var _a, _b, _c, _d, _e;
        if (state.hasSubmittedPromo) {
            (_a = this.badge) === null || _a === void 0 ? void 0 : _a.setAttribute('data-modal', 'modal_first_order_success');
        }
        else {
            (_b = this.badge) === null || _b === void 0 ? void 0 : _b.setAttribute('data-modal', 'modal_first_order');
        }
        if (state.hasSubmittedOrder) {
            (_c = this.badge) === null || _c === void 0 ? void 0 : _c.classList.add('hidden');
        }
        else {
            (_d = this.badge) === null || _d === void 0 ? void 0 : _d.classList.remove('hidden');
        }
        const newValue = (_e = this.badge) === null || _e === void 0 ? void 0 : _e.getAttribute('data-modal');
        const event = new CustomEvent('dataModalChanged', {
            detail: {
                element: this.badge,
                newValue,
            },
        });
        document.dispatchEvent(event);
        console.log('[PromoService] Dispatched dataModalChanged with newValue:', newValue);
    }
    remove() {
        this.listeners.forEach((unsubscribe) => unsubscribe());
    }
}
